export enum Archive {
    ZIP = "application/zip",
    TAR = "application/x-tar",
    RAR = "application/x-rar-compressed",
    Z = "application/x-7z-compressed",
}
